export const UPDATE_SUPPORTED_FEATURES = 'UPDATE_SUPPORTED_FEATURES';
